module.exports = __webpack_public_path__ + "img/emptystate.7eb34691.svg";